/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework from '@greenville/framework';
import { applySnapshot, types } from 'mobx-state-tree';
import * as constants from '../../../../../common/constants';

/** One row per (identifierId, agentName) pair, unlike the wide eText count rows. */
const otelCountRow = types.model('otelCountRow', {
  identifierId: types.maybeNull(types.string),
  agentName: types.maybeNull(types.string),
  agentCount: types.maybeNull(types.number),
  likeCount: types.maybeNull(types.number),
  disLikeCount: types.maybeNull(types.number),
  title: types.maybeNull(types.string)
});

const otelTrendLineRow = types.model('otelTrendLineRow', {
  dateStamp: types.maybeNull(types.string),
  identifierId: types.maybeNull(types.string),
  agentName: types.maybeNull(types.string),
  agentCount: types.maybeNull(types.number),
  likeCount: types.maybeNull(types.number),
  disLikeCount: types.maybeNull(types.number),
  title: types.maybeNull(types.string)
});

const OtelTrendsCount = types
  .model('OtelTrendsCount', {
    data: types.optional(types.array(otelCountRow), []),
    showTrendLineData: types.optional(types.array(otelTrendLineRow), []),
    totalRecords: types.maybeNull(types.number)
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.GET_OTEL_TRENDS_COUNT_DATA, { payload });
    },
    setResponse(response) {
      applySnapshot(self, {
        data: response?.data || [],
        showTrendLineData: response?.[constants.TRENDS_COUNT_SHOW_TREND_LINE_DATA] || [],
        totalRecords: response?.totalRecords ?? null
      });
    },
    resetStoreValues() {
      applySnapshot(self, { data: [], showTrendLineData: [], totalRecords: null });
    }
  }));

export default OtelTrendsCount;
